import * as React from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { isStringEmpty } from '../../../../util/string/is-string-empty.util';
import { Label } from '@atlaskit/field-base';
import { BlockColorEnum } from '../../../../enum/block-color.enum';
import { FormFieldSelectable } from './form-field-selectable';
import { draftToString } from '../../../../util/draft/draft-to-string.util';
import { IInjectedProps } from '../../../../interface/component/injected-props.interface';

const CheckableWrapper = styled.div`
  display:flex;
  align-items: center;
  margin-top: 15px;
`;

interface IBoolFieldProps {
  value: boolean;
  name: string;
  disabled: boolean;
  onChange: (newValue: any) => void;
  label: string;
  labelColor?: string;
  hasSiblings: boolean;
  yesTranslation: any;
  noTranslation: any;
  onBlur: () => void;
  isInvalid: boolean;
  required: boolean;
}

const BoolFieldContainer = styled.div`
  & label div {
    color: ${(props: { labelColor: string }) => props.labelColor ? props.labelColor : BlockColorEnum.PrimaryTextColor};
  }
`;

@inject('state')
@observer
export class BoolField extends React.Component<IBoolFieldProps & IInjectedProps> {
  onChange = (value?: boolean) => () => {
    const props = this.props;
    if (value === undefined) {
      props.onChange(!props.value);
    } else {
      props.onChange(value);
    }
  }

  render() {
    const props = this.props;
    if (props.hasSiblings) {
      return <CheckableWrapper>
        <FormFieldSelectable
          {...props}
          type="checkbox"
          onChange={this.onChange()}
          label={props.label}
          value={props.value}
          onClick={this.onChange()}
        />
      </CheckableWrapper>;
    }
    return (
      <BoolFieldContainer labelColor={props.labelColor}>
        {isStringEmpty(props.label) ? null : <Label
          isRequired={props.required}
          htmlFor={props.name}
          label={props.label}
        />}
        <CheckableWrapper>
          <FormFieldSelectable
            {...props}
            type="radio"
            onChange={this.onChange(true)}
            label={draftToString(this.props.yesTranslation, this.props.state)}
            value={props.value === true}
            onClick={this.onChange(true)}
          />
        </CheckableWrapper>
        <CheckableWrapper>
          <FormFieldSelectable
            {...props}
            type="radio"
            onChange={this.onChange(false)}
            label={draftToString(this.props.noTranslation, this.props.state)}
            value={props.value === false}
            onClick={this.onChange(false)}
          />
        </CheckableWrapper>
      </BoolFieldContainer>
    );
  }
}
